import { Alert, Box, Button, FormControl, SelectChangeEvent, TextField, Typography } from '@mui/material';
import { useUserActions } from 'actions/user-actions';
import { IUser } from 'common/interfaces/iuser';
import { FC, useEffect, useState } from 'react';
import { useAppSelector } from 'setup/store';
import UICard from 'components/lib/card/UICard';
import { toNumber } from 'lodash';
import { validateFormData } from 'common/utils';
import { useNavigate } from 'react-router-dom';
import { useAppActions } from 'actions/app-actions';
import { FormItem, SnackbarType } from 'common/interfaces';
import { postChangeUserPassword } from 'services/user-service';

type ChangeUserPasswordFormProps = {
  userData: IUser;
};

const DEFAULT_USER_DATA = {
  lastName: '',
  phoneNo: '',
  email: '',
} as IUser;

const FORM_FIELDS = [
  {
    itemKey: 'password',
    label: 'Password',
    type: 'textInput',
    minLength: 1,
    maxLength: 50,
    validationType: 'text',
    required: true,
  },
] as FormItem[];

const ChangeUserPasswordForm: FC<ChangeUserPasswordFormProps> = ({ userData }) => {
  const roleIdMap = useAppSelector((state) => state.userReducer.roleIdMap);
  const roles = useAppSelector((state) => state.userReducer.roles);
  const error = useAppSelector((store) => store.updateUserReducer.error);
  const updateError = useAppSelector((store) => store.updateUserReducer.error);
  const updating = useAppSelector((store) => store.updateUserReducer.loading);
  // const isUpdated = useAppSelector((store) => store.updateUserReducer.isUpdated);
  // const loggedInUser = useAppSelector((store) => store.appReducer.loggedInUser);

  const navigate = useNavigate();
  const [formError, setFormError] = useState<string>();
  const [password, setPassword] = useState<string>();
  const [_user, setUser] = useState<IUser>(userData);
  const { showSnackBar } = useAppActions();

  const validateForm = (value?: any) => {
    const validation = validateFormData(FORM_FIELDS, { password } as IUser, undefined, value);
    setFormError(validation?.error ? validation?.error['password'] : '');
    return validation.valid;
  };

  const _handleFormSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    const isValid = validateForm();
    if (_user && isValid && password) {
      const resp = await postChangeUserPassword(_user.id, password);
      if (resp) {
        showSnackBar(SnackbarType.SUCCESS, 'Updated successfully!');
        navigate('/users');
      }
    }
  };
  const _handleCancel = () => {
    navigate('/users');
  };

  return (
    <div>
      {error ? <Alert severity="error"> {error.msg}</Alert> : null}
      <Box
        component="form"
        sx={{
          '& .MuiTextField-root': { m: 1.5, width: '50ch' },
          '& .select': { m: 1.5, width: '50ch' },
          '& .selectLabel': { m: 1.5 },
          '& .MuiButton-root': { m: 1.5 },
          //   '& .MuiSelect-root': { m: 1, width: '30ch' },
        }}
        noValidate
        autoComplete="off"
      >
        {_user ? (
          <div>
            <UICard title="">
              <Box sx={{ padding: '15px' }}>
                <Typography variant="body1"> Name: {_user.displayName}</Typography>
                <Typography variant="body1"> Username: {_user.username}</Typography>
                <Typography variant="body1"> Role: {roleIdMap ? roleIdMap[_user.roleId].displayName : ''}</Typography>
              </Box>

              <FormControl fullWidth>
                <TextField
                  required
                  id="outlined-required"
                  label="Password"
                  value={password || ''}
                  error={formError ? true : false}
                  helperText={formError || ''}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setPassword(event.target.value);
                    validateForm(event.target.value);
                  }}
                  placeholder="Enter new password"
                />
              </FormControl>

              {updateError ? <Alert severity="error">{updateError?.msg}</Alert> : null}
              {/* {isUpdated ? <Alert severity="success">{'Updated successfully!'}</Alert> : null} */}
              <Button
                disabled={updating}
                variant="contained"
                onClick={_handleFormSubmit}
                style={{ marginTop: '30px' }}
                loading={updating}
              >
                Submit
              </Button>
              <Button
                disabled={updating}
                variant="contained"
                onClick={_handleCancel}
                style={{ marginTop: '30px' }}
                loading={updating}
                color="error"
              >
                Cancel
              </Button>
            </UICard>
          </div>
        ) : null}
      </Box>
    </div>
  );
};

export default ChangeUserPasswordForm;
